import { AuthXInterceptor } from '../Config/AuthXInterceptor'

export interface DashboardMetrics {
  totalUsers: number
  totalNewUsersInRange: number
  totalActiveStations: number
  totalVolumeToday: number
  totalVolumeInRange: number
  transactionVolumeGraph: Array<{
    date: string
    value: number
  }>
  userRegistrationGraph: Array<{
    date: string
    value: number
  }>
  period: {
    startDate: string
    endDate: string
  }
}

export const dashboardBXService = {
  // Get dashboard metrics
  getMetrics: async (params?: { 'startDateYYYY_MM_DD'?: string; 'endDateYYYY_MM_DD'?: string }) => {
    return await AuthXInterceptor.get('metrics/dashboard', { params })
  },
}
